const faqs = [
    { 
        id: 1, 
        heading: 'How do I install the CCTV system?',
        content: 'Installing your CCTV system is straightforward with our step-by-step guide. You can also request professional installation services to ensure optimal setup and functionality.',
    }, 
    {
        id: 2,
        heading: 'Can I monitor my cameras remotely?',
        content: 'Yes, our systems support remote monitoring via smartphone apps or desktop software. Stay connected to your property from anywhere in the world with real-time video feeds.',
    },
    { 
        id: 3,
        heading: 'How is video footage stored?',
        content: 'Video footage is stored securely on DVRs, NVRs, or cloud-based storage, depending on your chosen system. Our solutions ensure easy access and safe storage for your recordings.',
    },
    {
        id: 4,
        heading: 'How do I maintain my security system?',
        content: 'Regular maintenance involves cleaning your cameras, checking cables for wear, and updating firmware. We also offer maintenance packages for hassle-free system care.',
    },
    {
        id: 5,
        heading: 'What is covered under the warranty?',
        content: 'Our systems come with a comprehensive warranty covering manufacturing defects and hardware issues. Contact our support team for assistance with warranty claims.',
    },
];

export default faqs;